import { render, staticRenderFns } from "./MMP_HDT_PointCloud.vue?vue&type=template&id=bc35a6f4&"
import script from "./MMP_HDT_PointCloud.vue?vue&type=script&lang=js&"
export * from "./MMP_HDT_PointCloud.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports